import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { containerS } from "../../../styles/containerStyles";
import FormBtns from "../../../../common/layout/form/NewFormBtns";
import FormDropDown from "../../../../common/layout/form/FormDropDown";
import ActivityIndicator from "../../../../common/layout/ActivityIndicator";
import MessageContainer from "../../../../auth/components/register/forms/MessageContainer";
import { useEndOrder } from "../../../hooks/useCompleteOrder";
import ReadOnlyDetails from "./ReadOnlyDetails";
import NewFormField from "../../../../common/layout/form/NewFormField";
import { useMatchedVehicles } from "../../../hooks/useMatchedVehicles";
import { completeOrderValidation } from "../../../actions/validationSchemas";
import { useOperators } from "../../../hooks/useOperators";
import { useOrderTypes } from "../../../hooks/useOrderTypes";
import Quantities from "./Qunatities";
import DateOfCompletion from "./DateOfCompletion";
import Prices from "./Prices";
import { divider, filedS, fieldContainer } from "../../../styles/realizationOrderForm.styles";
import { mergeStyles } from "@uifabric/merge-styles";
import { useOrderInternalStores } from "../../../hooks/useOrderInternalStores";
import OrderDetailTxt from "../edditOrder/OrderDetailTxt";

export interface RealizationOrderFormProps { }

const RealizationOrderForm: React.FC<RealizationOrderFormProps> = () => {
    const { t } = useTranslation("admin");
    const {
        initValues,
        handleSubmit,
        isLoading,
        cancelForm,
        orderDetails,
    } = useEndOrder();
    const { vehicles } = useMatchedVehicles([orderDetails.orderInfo == null ? null : orderDetails.orderInfo.id]);
    const [price, setPrice] = useState<any>("");
    const { operators } = useOperators();

    const orderTypeId = orderDetails ? orderDetails.orderTypeId : "";
    const orderId = orderDetails ? (orderDetails.orderInfo ? orderDetails.orderInfo.id : "") : "";
    const { orderTypes } = useOrderTypes(orderTypeId);
    const { internalStores, averageDistance } = useOrderInternalStores(orderId)

    var averageDistanceStr = internalStores.length > 0
        ? t("nav.averageDistanceFromWarehouse", { distance: averageDistance })
        : t("nav.noAddressIdentified");

    const container = mergeStyles({
        display: "flex",
        justifyContent: "space-between",
        marginTop: 15
    })

    return (
        <div className={containerS}>
            <ReadOnlyDetails />

            {orderDetails && orderDetails.cuoOrderDetails && (
                <div style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: '0 0 10px 0', color: '#0078d4', fontSize: '14px' }}>{t("nav.panelInfoFromCuo")}</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                        <OrderDetailTxt
                            title={t("nav.cuoNumber")}
                            value={orderDetails.cuoOrderDetails.cuoOrderNumber || t("nav.notAvailable")}
                        />
                        <OrderDetailTxt
                            title={t("nav.cuoOperator")}
                            value={orderDetails.cuoOrderDetails.operatorName || t("nav.notAvailable")}
                        />
                        <OrderDetailTxt
                            title={t("nav.cuoAddress")}
                            value={orderDetails.cuoOrderDetails.address || t("nav.notAvailable")}
                        />
                        <OrderDetailTxt
                            title={t("nav.tireType")}
                            value={orderDetails.cuoTireType === null ? t("nav.mixed") : orderDetails.cuoTireType || t("nav.notAvailable")}
                        />
                        <OrderDetailTxt
                            title={t("nav.tireCount")}
                            value={`${orderDetails.cuoOrderDetails.totalTiresOrdered || 0} ${t("orders.details.unit")}`}
                        />
                    </div>
                </div>
            )}

            <Formik
                enableReinitialize={true}
                initialValues={initValues}
                onSubmit={handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
                validationSchema={completeOrderValidation}
            >
                {({ values }) => (
                    <Form>
                        <div className={divider}>
                            <FormDropDown
                                name="driver"
                                headerText={t("nav.panelDriverVehicle") as string}
                                options={vehicles}
                            />
                        </div>
                        <div className={divider}>
                            <FormDropDown
                                name="operator"
                                headerText={t("nav.panelHandlingOperator") as string}
                                options={operators}
                            />
                        </div>
                        <div className={container}>
                            <div className={filedS}>
                                <NewFormField name="tonnage" label={t("nav.tonnageLabel") as string} />
                            </div>
                            <div className={filedS}>
                                <NewFormField name="kpo" label={t("nav.kpoLabel") as string} />
                            </div>
                        </div>
                        <DateOfCompletion name="receivingDate" values={values} />
                        <div className={divider}>
                            <FormDropDown
                                name="orderTypeItemId"
                                headerText={t("nav.panelType") as string}
                                options={orderTypes}
                                onChangeEffect={setPrice}
                            />
                        </div>
                        <div>
                            <FormDropDown
                                name="internalStoreId"
                                headerText={t("nav.panelRecycleWarehouse") as string}
                                options={internalStores}
                                additionalInfo={averageDistanceStr}
                            />
                        </div>
                        <Quantities />
                        {<div className={divider}>
                            <NewFormField
                                name="updatedPrice"
                                label={t("nav.newPrice") as string}
                                type="number"
                                placeholder={t("nav.newPricePlaceholder") as string}
                                notRequired
                            />
                        </div>}
                        <Prices
                            price={values.updatedPrice !== undefined ? values.updatedPrice : (orderDetails.netPrice ? orderDetails.netPrice : "")}
                            quantity={values.quantityTaken}
                            orderDetails={orderDetails}
                            tonnage={values.tonnage}
                        />
                        <FormBtns
                            submitBtnText={t("nav.finish") as string}
                            cancelForm={cancelForm}
                            disabled={isLoading}
                        />
                        {isLoading ? <ActivityIndicator /> : <MessageContainer />}
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default RealizationOrderForm;